import { ACTION } from './constants';
import request from '../../../../utils/request';
import { requestConfig } from '../../../../config/apiResource';
import {showMainLoader, hideMainLoader} from '../../../actions';
import { formDataGenerator } from "../../../../utils/common";


export function getHome() {
    return dispatch => {
        return request(requestConfig.getHome())
            .then((json) => {
                json && dispatch({ type: ACTION.GET_HOME_CONTENT, data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with Home data: " + error)
            });
    }
}
export function allAnnouncementMeta(type) {
    let typeData;
    if(!__CLIENT__){
        typeData = 'important-announcement';
    }else{
        typeData = type;
    }

    return dispatch => {
        return request(requestConfig.allSectionsMeta(typeData))
            .then((json) => {
                json && dispatch({ type: ACTION.IMP_ANNOUNCEMENT_META, data: json });
                return json;
            }).catch((error) => {
                console.log("Got Error with verify pan folio data: " + error)
            });
    }
}
export function getGoals() {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getGoals())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_GOALS_CONTENT, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Learn data: " + error)
            });
    }
}
export function getGoalQuestions(goalId) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getGoalQuestions(goalId))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_GOAL_QUESTION, data: json });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Learn data: " + error)
            });
    }
}
export function getGoalSuggestions(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getGoalSuggestions(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_GOAL_SUGGESTION, data: json });
            
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Learn data: " + error)
            });
    }
}

export function verifyPAN() {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.verifyPAN())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.VERIFY_PAN, data: json });
            
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Learn data: " + error)
            });
    }
}

export function verifyKYC(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.verifyKYC(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.VERIFY_KYC, data: JSON.parse(decryptAES(response)) });
                return JSON.parse(decryptAES(response));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Verify KYC data: " + error)
            });
    }
}

export function savePreLoginData(params, uuid) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.savePreLoginData(params, uuid))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.SAVE_PRE_LOGIN_DATA, data: JSON.parse(decryptAES(response)) });
                return JSON.parse(decryptAES(response));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with save prelogin data: " + error)
            });
    }
}
export function validateBasketSchemes(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.validateBasketSchemes(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.VALIDATE_BASKET_SCHEMES, data: JSON.parse(decryptAES(response)) });
                return JSON.parse(decryptAES(response));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with validate basket data: " + error)
            });
    }
}
export function verifyOTP(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.verifyOTPJava(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.VERIFY_OTP, data: JSON.parse(decryptAES(response)) });
                return JSON.parse(decryptAES(response));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Verify OTP data: " + error)
            });
    }
}

export function resendOTP(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.resendOTPJava(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.RESEND_OTP, data: JSON.parse(decryptAES(response)) });
                return JSON.parse(decryptAES(response));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Resend OTP data: " + error)
            });
    }
}

export function cleanGoalsContent() {
    return {type: ACTION.CLEAN_GOALS_CONTENT}
}

export function cleanAuthContent() {
    return {type: ACTION.CLEAN_AUTH_CONTENT}
}

export function getRiskQuestionAns(){
    return dispatch => {
            dispatch(showMainLoader());
            return request(requestConfig.getRiskQuestionAns())
                .then((json) => {
                    dispatch(hideMainLoader());
                    json && dispatch({ type: ACTION.GET_RISK_QUESTION_ANS, data: json });
                
                    return json;
                }).catch((error) => {
                    dispatch(hideMainLoader());
                    console.log("Got Error with Learn data: " + error)
                });
        }
}

export function evaluateRiskAppetite(params){
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.evaluateRiskAppetite(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.EVALUATE_RISK_APPETITE, data: json });
            
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Learn data: " + error)
            });
    }
}

export function getBasketRecommendation(params){
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getBasketRecommendation(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_BASKET_RECOMMENDATION, data: json });
            
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Learn data: " + error)
            });
    }
}

export function getRiskAppetitesList(){
    return dispatch => {
            dispatch(showMainLoader());
            return request(requestConfig.getRiskAppetitesList())
                .then((json) => {
                    dispatch(hideMainLoader());
                    json && dispatch({ type: ACTION.GET_RISK_APPETITES_LIST, data: json });
                
                    return json;
                }).catch((error) => {
                    dispatch(hideMainLoader());
                    console.log("Got Error with Learn data: " + error)
                });
        }
}


export function getHomePageDataStatic(params){
    let formDataValue;
    if(!__CLIENT__){
        let data = {
            sliderID:'home',
            youTubeShort : 'mutual-fund-shorts',
            fundOfferingID : 'new-fund-offering',
            homePageID: 'home-page',
        };
        formDataValue = formDataGenerator(data);
    }else{
        formDataValue = params;
    }

    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getHomePageDataStatic(formDataValue))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_HOMEPAGE_DATA, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with get homePage data: " + error)
            });
    }
}
export function getHomePageAnnouncement(params){
    let formDataValue;
    if(!__CLIENT__){
        let data = {
            regulatoryID : 'regulatory-announcements'
        };
        formDataValue = formDataGenerator(data);
    }else{
        formDataValue = params;
    }

    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getHomePageDataStatic(formDataValue))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_HOMEPAGE_DATA, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with get homePage data: " + error)
            });
    }
}
export function getTrendingFundData(){
    return dispatch => {
            dispatch(showMainLoader());
            return request(requestConfig.getTrendingFundData())
                .then((json) => {
                    dispatch(hideMainLoader());
                    json && dispatch({ type: ACTION.GET_TRENDING_FUND_DATA, data: json });
                    return json;
                }).catch((error) => {
                    dispatch(hideMainLoader());
                    console.log("Got Error with  get trending fund data: " + error)
                });
        }
}
export function getYoutubeShorts(){
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getYoutubeShorts())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_YOUTUBE_SHORTS_DATA, data: json });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with get md message data: " + error)
            });
    }
}

export function cleanRiskContent() {
    return {type: ACTION.CLEAN_RISK_CONTENT}
}

export function cleanGoalsQuestion() {
    return {type: ACTION.CLEAN_GOALS_QUESTIONS}
}

const encryptRSA = (data) => {
    /*Encrypt*/
    let crypt = new JSEncrypt();
    crypt.setKey(ACTION.PASS_PUB_KEY);
    // Encrypt the data with the public key.
    return crypt.encrypt(data);
}

const decrypttRSA = (data) => {
    /*Encrypt*/
    let crypt = new JSEncrypt();
    crypt.setKey(ACTION.PRIV_KEY);
    // Encrypt the data with the public key.
    return crypt.decrypt(data);
}

const decryptAES = (encryptedData) => {
    let crypt = new JSEncrypt();
    crypt.setKey(ACTION.PRIV_KEY);
    let header = encryptedData.substring(0, encryptedData.lastIndexOf("|"));
    let data = CryptoJS.enc.Base64.parse(encryptedData.substring(encryptedData.lastIndexOf("|")+1, encryptedData.length));
    let responseData = readAesResponsePayload(crypt.decrypt(header), data);
    return responseData;
    // response.data = angular.fromJson(responseData);
}

const readAesResponsePayload = (header, data) => {
    let iv = CryptoJS.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
    let key = CryptoJS.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));
    let decryptJson = CryptoJS.AES.decrypt({
      ciphertext: data
    }, key, {iv: iv});
    return decryptJson.toString(CryptoJS.enc.Utf8);
  }

function encryptAES(data) {
    let crypt = new JSEncrypt();
    crypt.setKey(ACTION.PASS_PUB_KEY);
    let key =  CryptoJS.lib.WordArray.random(128/8); //16bit
    let IV =  CryptoJS.lib.WordArray.random(128/8); //8bit
    let aesEncrypted = CryptoJS.AES.encrypt(data, key, { iv: IV });
    let ivAndKey = CryptoJS.enc.Base64.stringify(IV) + "|" + CryptoJS.enc.Base64.stringify(key);
    return (crypt.encrypt(ivAndKey) + "|" + CryptoJS.enc.Base64.stringify(aesEncrypted.ciphertext));
}

function encryptAESforKYC(data) {
    let cypherText = CryptoJS.AES.encrypt(JSON.stringify(data), 'tgkpdi45sd');
    return (cypherText.toString());
}

export { encryptAES, readAesResponsePayload, decryptAES, decrypttRSA, encryptRSA, encryptAESforKYC }